import {useQuery} from '@tanstack/react-query';
import {rqCreateRequest, rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {
  RQ_CREATE_STATE_API,
  RQ_GET_STATE_API,
  RQ_GET_STATE_FIND_BY_ID,
  RQ_UPDATE_STATE_ALL_FIELDS_API,
} from '@app/reactQuery/apis/constants/rqStateAPIConstants';

export const RQUseGetStateData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_state_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_STATE_API,
        null,
        certificate,
        null,
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetStateFindById = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_state_find_by_id', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, id} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_STATE_FIND_BY_ID,
        null,
        certificate,
        {id:id},
        signal,
      );
    },
    ...options,
  });
};

export const RQPutStateUpdateAllField = async ({
  state,
  certificate,
  signal,
  id,
}) => {
  return rqCreateRequest(
    RQ_UPDATE_STATE_ALL_FIELDS_API,
    JSON.stringify({...state, id:id}),
    certificate,
    null,
    signal,
  );
};

export const RQPutCreateState = ({state, certificate, signal}) => {
  return rqCreateRequest(
    RQ_CREATE_STATE_API,
    JSON.stringify({...state}),
    certificate,
    null,
    signal,
  );
};
